import {useEffect} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {isAndroid, isIOS, isDesktop} from 'react-device-detect';
import {androidStoreUrl, convertToOrderDeeplink, iosStoreUrl} from 'utils';

const useCreateOrderInAppOrDownload = () => {
  const {country_code: countryCode, store_id, order_campaign_referred_code} = useParams();
  const [search] = useSearchParams();

  const storeId = store_id || search.get('store_id');
  const code = order_campaign_referred_code || search.get('order_campaign_referred_code');
  const checkoutId = search.get('checkout_id');

  useEffect(() => {
    if (!countryCode || isDesktop) return;

    const deepLinkUrl = convertToOrderDeeplink(countryCode, storeId, code, checkoutId);
    const storeUrl = isAndroid ? androidStoreUrl() : isIOS ? iosStoreUrl(countryCode) : '';

    if (deepLinkUrl) window.location.replace(deepLinkUrl);

    const timeout = setTimeout(() => {
      if (storeUrl) window.location.replace(storeUrl);
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [countryCode, storeId, code, checkoutId]);
};

export default useCreateOrderInAppOrDownload;
